import React, { Component } from 'react';
import PropTypes from 'prop-types';

let id = 0;

/*
 * Component that displays an SVG gradient representing a color legend
 */
class Legend extends Component {
  static propTypes = {
    // Width of the rectangle
    width: PropTypes.number.isRequired,

    // Height of the rectangle
    height: PropTypes.number.isRequired,

    // d3 color function mapping [0,1] to a color
    color: PropTypes.func.isRequired,

    // Array of numbers to map color range
    range: PropTypes.arrayOf(PropTypes.number),
  };

  static defaultProps = {
    range: [0, 0.25, 0.5, 0.75, 1],
  };

  constructor(props) {
    super(props);
    id += 1;
    this.id = id;
  }

  render() {
    const { width, height, color, range } = this.props;

    const stopFunction = (value, idx, rangeArr) => {
      const scoreRange = rangeArr[rangeArr.length - 1] - rangeArr[0];
      const scorePct = (100 * (rangeArr[idx] - rangeArr[0])) / scoreRange;
      return (
        <stop
          key={idx}
          offset={`${scorePct}%`}
          style={{ stopColor: color(value) }}
        />
      );
    };

    // Fixed text area widths - gradient fills remaining space
    const leftTextWidth = 15;
    const rightTextWidth = 15;
    const gradientStartX = leftTextWidth;
    const gradientWidth = width - leftTextWidth - rightTextWidth;

    return (
      <div>
        <svg width={width} height={height}>
          <defs>
            <linearGradient
              id={`legend${this.id}`}
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%"
              spreadMethod="pad"
            >
              {range.map(stopFunction)}
            </linearGradient>
          </defs>
          <rect
            width={gradientWidth}
            height={height}
            x={gradientStartX}
            y="0"
            fill={`url(#legend${this.id})`}
          />
          <text x="0" y={height / 2 + 5}>
            {range[0]}
          </text>
          <text x={width} y={height / 2 + 5} textAnchor="end">
            {range[range.length - 1]}
          </text>
        </svg>
      </div>
    );
  }
}

export default Legend;
